export default __webpack_public_path__ + "static/cashflow_new_13-ec5e5ba9337c8bb2dfb68ebef569c912.jpg";